var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonSendAltFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9781 4.02206C25.8515 3.89612 25.6917 3.80893 25.5173 3.77074C25.3429 3.73254 25.1613 3.74492 24.9937 3.80643L4.36869 11.3064C4.19082 11.3739 4.03768 11.4939 3.92961 11.6504C3.82155 11.807 3.76367 11.9928 3.76367 12.183C3.76367 12.3732 3.82155 12.559 3.92961 12.7155C4.03768 12.8721 4.19082 12.9921 4.36869 13.0596L12.4218 16.2752L18.3656 10.3127L19.6874 11.6346L13.7156 17.6064L16.9406 25.6596C17.01 25.834 17.1303 25.9835 17.2857 26.0889C17.4412 26.1942 17.6247 26.2504 17.8124 26.2502C18.0019 26.2463 18.1857 26.1851 18.3397 26.0746C18.4937 25.9642 18.6106 25.8096 18.6749 25.6314L26.1749 5.00643C26.2388 4.84056 26.2542 4.65996 26.2194 4.48567C26.1845 4.31138 26.1008 4.1506 25.9781 4.02206Z",
    fill: "#041018"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonSendAltFilled);
export default __webpack_public_path__ + "static/media/carbon_send-alt-filled.1fcbee1e.svg";
export { ForwardRef as ReactComponent };